/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-use-before-define */
import React, { useState, useEffect, useRef } from 'react';
import QuickAccessMenu from './QuickAccessMenu';
import QuickAccessSearch from './QuickAccessSearch';
import './styles.scss';

const SettingsQuickAccess = ({
  bot,
  item,
  user,
  updateBotQuickAccess,
  updatePublishBotQuickAccess,
}) => {
  const rules = {
    Manual: 'manual',
    '+ Acessados do Dia': 'lastday',
    '+ Acessados do Semana': 'lastweek',
    '+ Acessados do Mês': 'lastmonth',
  };

  const labels = {
    manual: 'Manual',
    lastday: '+ Acessados do Dia',
    lastweek: '+ Acessados do Semana',
    lastmonth: '+ Acessados do Mês',
  };

  const handleMaxNumberItensStart = (maxNumber) => {
    let result = '';

    if (maxNumber !== 0) {
      result = maxNumber;
    }

    return result;
  };

  const selectListType = (quickAccess) => {
    const {
      sortingRules,
      manualList,
      lasdayList,
      lastweekList,
      lastmonthList,
    } = quickAccess;

    const selector = {
      manual: manualList,
      lastday: lasdayList,
      lastweek: lastweekList,
      lastmonth: lastmonthList,
    };

    const list = selector[sortingRules];

    return list || [];
  };

  const [quickAccessList, setQuickAccessList] = useState([]);
  const [searchList, setSearchList] = useState([]);
  const [menuList, setMenuList] = useState(
    bot && bot.quickAccess ? selectListType(bot.quickAccess) : []
  );
  const [manualList, setManualList] = useState(
    bot && bot.quickAccess ? bot.quickAccess.manualList : []
  );
  const [lasdayList, setLasdayList] = useState(
    bot && bot.quickAccess ? bot.quickAccess.lasdayList : []
  );
  const [lastweekList, setLastweekList] = useState(
    bot && bot.quickAccess ? bot.quickAccess.lastweekList : []
  );
  const [lastmonthList, setLastmonthList] = useState(
    bot && bot.quickAccess ? bot.quickAccess.lastmonthList : []
  );
  const [maxNumberItens, setMaxNumberItens] = useState(
    bot && bot.quickAccess ? bot.quickAccess.maxNumberItens : ''
  );
  const [tempMaxNumberItens, setTempMaxNumberItens] = useState(
    bot && bot.quickAccess
      ? handleMaxNumberItensStart(bot.quickAccess.maxNumberItens)
      : ''
  );
  const [quickAccessActive, setQuickAccessActive] = useState(
    bot && bot.quickAccess ? bot.quickAccess.quickAccessActive : false
  );
  const [isDropRulesHidden, setIsDropRulesHidden] = useState(true);
  const [currentRuleSelect, setCurrentRuleSelect] = useState(
    bot && bot.quickAccess
      ? labels[`${bot.quickAccess.sortingRules}`]
      : 'Selecione'
  );

  const [publishRule, setPublishRule] = useState(
    bot && bot.quickAccess && bot.quickAccess.ableToReorder
      ? bot.quickAccess.sortingRules
      : null
  );

  const [viewer, setViewer] = useState(false);
  const quickAccessWrapperRef = useRef(null);

  const updateChosenList = () => {
    const select = {
      manual: setManualList,
      lastday: setLasdayList,
      lastweek: setLastweekList,
      lastmonth: setLastmonthList,
    };

    const rule = rules[currentRuleSelect];

    const chosenFunction = select[rule];
    if (chosenFunction) {
      chosenFunction(menuList);
    }
  };

  useEffect(() => {
    if (bot && bot.quickAccess) {
      const { quickAccess } = bot;
      setMenuList(selectListType(quickAccess));
      setManualList(quickAccess.manualList);
      setLasdayList(quickAccess.lasdayList);
      setLastweekList(quickAccess.lastweekList);
      setLastmonthList(quickAccess.lastmonthList);
      setQuickAccessActive(quickAccess.quickAccessActive);
      setCurrentRuleSelect(labels[`${quickAccess.sortingRules}`]);
      setMaxNumberItens(quickAccess.maxNumberItens);
    }
  }, [bot]);

  useEffect(() => {
    if (bot && item && item.allItems) {
      const activeList = [];
      // eslint-disable-next-line no-shadow
      item.allItems.forEach((item) => {
        if (item.quickAccess) {
          activeList.push({ _id: item._id, title: item.title });
        }
      });
      setQuickAccessList(activeList);
    }
  }, [bot, item]);

  useEffect(() => {
    if (menuList.length >= 0) {
      const nsearchList = quickAccessList.filter((listItem) => {
        let belong = true;
        menuList.forEach((MenuItem) => {
          if (MenuItem._id === listItem._id) {
            belong = false;
          }
        });
        return belong;
      });
      setSearchList(nsearchList);
      updateChosenList();
    } else {
      setSearchList(quickAccessList);
    }
  }, [quickAccessList, menuList]);

  useEffect(() => {
    document.addEventListener('click', onClickOutsideComponent, false);
    return () => {
      document.removeEventListener('click', onClickOutsideComponent, false);
    };
  }, []);

  useEffect(() => {
    if (user?.selectedCompany?.claim?.name === 'Viewer') {
      setViewer(true);
    }
  }, []);

  const handleUpdateBot = () => {
    if (bot && !viewer) {
      const data = {
        quickAccessActive,
        maxNumberItens: +maxNumberItens,
        sortingRules: rules[currentRuleSelect] || 'manual',
        manualList,
        lasdayList,
        lastweekList,
        lastmonthList,
      };
      setPublishRule(null);
      updateBotQuickAccess(bot._id, data);
    }
  };

  const handleUpdatePublishBot = () => {
    if (bot && !viewer) {
      const data = {
        quickAccessActive,
        maxNumberItens: +maxNumberItens,
        sortingRules: rules[currentRuleSelect] || 'manual',
        manualList,
        lasdayList,
        lastweekList,
        lastmonthList,
      };
      setPublishRule(rules[currentRuleSelect] || 'manual');
      updatePublishBotQuickAccess(bot._id, data);
    }
  };

  const handleTempMaximumNumberItems = (number) => {
    const pnumber = parseFloat(number);
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(pnumber)) {
      setTempMaxNumberItens('');
    } else if (pnumber > 10) {
      setTempMaxNumberItens(10);
    } else if (pnumber <= 0) {
      setTempMaxNumberItens('');
    } else {
      setTempMaxNumberItens(number);
    }
  };

  const handleMaximumNumberItems = () => {
    setMaxNumberItens(tempMaxNumberItens);
    if (tempMaxNumberItens !== '') {
      setMenuList([...menuList].slice(0, tempMaxNumberItens));
    }
  };

  const onClickOutsideComponent = (event) => {
    if (
      quickAccessWrapperRef.current &&
      !quickAccessWrapperRef.current.contains(event.target)
    ) {
      setIsDropRulesHidden(true);
    }
  };

  const showSortingRulesDropdown = () => {
    setIsDropRulesHidden(!isDropRulesHidden);
  };

  const handleCurrentRuleSelect = (props) => {
    setCurrentRuleSelect(labels[`${props}`]);
    const selector = {
      manual: manualList,
      lastday: lasdayList,
      lastweek: lastweekList,
      lastmonth: lastmonthList,
    };

    setMenuList(selector[props] ? selector[props] : []);

    setIsDropRulesHidden(true);
  };

  const renderSortingRoles = () => {
    return (
      <div className="quick-access-sorting-rule" ref={quickAccessWrapperRef}>
        <label>Regra de Ordenação</label>
        <div
          className="human-type-options"
          onClick={
            user?.selectedCompany?.claim?.name !== 'Viewer'
              ? () => showSortingRulesDropdown()
              : ''
          }
        >
          <input
            disabled
            id="human-type-options-input"
            type="text"
            value={currentRuleSelect}
            style={{
              backgroundColor:
                labels[publishRule] === currentRuleSelect ? '#ff9d8a' : '',
            }}
          />
          <i className="arrow-down" />
        </div>
        <div className="quick-access-rules-dropdown" hidden={isDropRulesHidden}>
          <div
            className="select-rule-option"
            style={{
              backgroundColor: publishRule === 'manual' ? '#ff9d8a' : '',
            }}
            onClick={() => {
              handleCurrentRuleSelect('manual');
            }}
          >
            Manual
          </div>
          <div
            className="select-rule-option"
            style={{
              backgroundColor: publishRule === 'lastday' ? '#ff9d8a' : '',
            }}
            onClick={() => {
              handleCurrentRuleSelect('lastday');
            }}
          >
            + Acessados do Dia
          </div>
          <div
            className="select-rule-option"
            style={{
              backgroundColor: publishRule === 'lastweek' ? '#ff9d8a' : '',
            }}
            onClick={() => {
              handleCurrentRuleSelect('lastweek');
            }}
          >
            + Acessados da Semana
          </div>
          <div
            className="select-rule-option"
            style={{
              backgroundColor: publishRule === 'lastmonth' ? '#ff9d8a' : '',
            }}
            onClick={() => {
              handleCurrentRuleSelect('lastmonth');
            }}
          >
            + Acessados do Mês
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="container-all-quick-access">
      <div className="container-settings-quick-access">
        <div>
          Configuração do Bot <b>Acesso Rápido</b>
          <div className="form-group row mb-1 quick quick-access-toggle">
            <div className="custom-control custom-switch mt-2 toggle-quick-access">
              <input
                type="checkbox"
                className="custom-control-input"
                id="quickAccess"
                checked={quickAccessActive}
                onChange={() => {
                  setQuickAccessActive(!quickAccessActive);
                }}
              />
              <label className="custom-control-label" htmlFor="quickAccess">
                Ativar Acesso Rápido no WebChat
              </label>
            </div>
          </div>
          <div className="max-amount-itens">
            <div>Quantidade Máxima de Itens Exibidos</div>
            <input
              placeholder="10"
              value={tempMaxNumberItens}
              onChange={(e) => handleTempMaximumNumberItems(e.target.value)}
              onBlur={handleMaximumNumberItems}
            />
          </div>
          {renderSortingRoles()}
          <QuickAccessSearch
            searchList={searchList}
            setSearchList={setSearchList}
            menuList={menuList}
            setMenuList={setMenuList}
            quickAccessList={quickAccessList}
            maxNumberItens={maxNumberItens}
          />
        </div>
        <div className="quick-access-save-buttons">
          <button
            onClick={handleUpdateBot}
            className={viewer ? 'btn-blue-save-inactive' : 'btn-blue-save'}
            type="button"
          >
            salvar
          </button>
          <button
            onClick={handleUpdatePublishBot}
            className={viewer ? 'btn-blue-save-inactive' : 'btn-blue-save'}
            type="button"
          >
            salvar e publicar
          </button>
        </div>
      </div>
      <div
        className="container-quick-access-list"
        style={menuList.length > 0 ? { opacity: 1 } : { opacity: 0.3 }}
      >
        <QuickAccessMenu
          menuList={menuList}
          setMenuList={setMenuList}
          searchList={searchList}
          setSearchList={setSearchList}
          maxNumberItens={maxNumberItens}
        />
      </div>
    </div>
  );
};

export default SettingsQuickAccess;
